import { legacy_createStore as createStore, combineReducers } from 'redux';

// Ejemplo de un reducer simple
const ejemploReducer = (state = {}, action: any) => {
  switch (action.type) {
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  ejemplo: ejemploReducer, // Asegúrate de tener al menos un reducer válido
});

export const store = createStore(rootReducer);

export type RootState = ReturnType<typeof rootReducer>;